import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['setEtapes', 'setEtapeBar']),
    initProgressBar(nbEtapes, nomEtapes, nbEtapeActive, titre) {
      const etapes = [];

      for (let i = 1; i <= nbEtapes; i++) {
        etapes.push({ id: i, nom: nomEtapes[i - 1], active: nbEtapeActive === i ? 'active' : '' });
      }
      this.setEtapes(etapes);
      const width = (nbEtapeActive / nbEtapes) * 100;
      const etapeBar = {
        currentStep: nbEtapeActive,
        lastStep: nbEtapes,
        valueNow: width,
        valueMin: 0,
        valueMax: 100,
        width: `width:${width}%;`,
        titre,
      };
      this.setEtapeBar(etapeBar);
    },
  },

};
